import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider } from "formik";

import { Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const CaisseEspaceAdd = () => {
  const [permission, setPermission] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('dh');

  // const [paymentMethods, setPaymentMethods] = useState([]);  
  let season_id = localStorage.getItem("season_id");

  const paymenttypes = ([
    // { value: 'Virement', label: "Virement" },
    // { value: 'Cheque', label: "Cheque" },
    { value: 'Espece', label: "Espece" },
  ]);
  const chequelist = ([
    { value: 'Encaisse', label: "Encaisse" },
    { value: 'Non Encaisse', label: "Non Encaisse" }
  ]);

  const operationtypes = ([
    { value: 'Vente déchets', label: "Vente déchets" },
    { value: 'MAD', label: "MAD" },
    { value: 'Avance', label: "Avance" },
    { value: 'Alimentation Caisse', label: "Alimentation Caisse" },
    { value: 'Divers', label: "Divers" },
    { value: 'Autre', label: "Autre" }
  ]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const defaultDate = (formatDate(new Date()));


  const initialValues = {
    date: defaultDate,
    season_id: season_id,
    amount: "",
    expense_type_other: '',
    operation_type_other: '',
    payment_method: "2",
    transaction_type: 'espece',
    currency: "4",
    note: "",
    operation: "",
    payed_to: "",
    expense_type: "",
    operation_type: '',
    paid_by: "",
    payment_type: "Espece",
    cheque: ""
  };

  const formik = useFormik({
    initialValues,
    onSubmit: (values, { setSubmitting }) => {
      if (isSubmitting) return; // Prevent multiple submissions

      setIsSubmitting(true);
      $("#form-submit").text("Processing...").prop("disabled", true);

      axios
        .post("/caisse/add", values, {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {

          delete backendErrors['error'];
          setSubmitting(false);
          setIsSubmitting(false);
          $("#form-submit").text("Add Caisse Bank").prop("disabled", false);

          if (response.data.code === 200) {
            formik.resetForm({ values: initialValues });

            toast.success(response.data.message);
            //   actions.resetForm();

            setTimeout(() => {
              window.location.href = "/caisse-espece";
            }, 500);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          setIsSubmitting(false);
          $("#form-submit").text("Add Caisse Bank").prop("disabled", false);
          toast.error(error.message || "An error occurred");
        });
    },
  });


  useEffect(() => {
    setPermission(FindModuleById(311));
    console.log(permission);

  }, []);
  const [selectedOperation, setSelectedOperation] = useState('');
  const [checklistshow, setChecklistshow] = useState('');


  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  const selectPaymentType = (event) => {
    const peymenttype = event.value;
    if (peymenttype == 'Cheque') {
      setChecklistshow(peymenttype);
    } else {
      setChecklistshow('');

    }

  };
  const primaryCurrency = [
    {
      "label": "EUR",
      "value": 1,
      "symbol": "€",
      "key": "cabrane-0"
    },
    {
      "label": "USD",
      "value": 2,
      "symbol": "$",
      "key": "cabrane-1"
    },
    {
      "label": "GBP",
      "value": 3,
      "symbol": "£",
      "key": "cabrane-2"
    },
    {
      "label": "MAD ",
      "value": 4,
      "symbol": "dh",
      "key": "cabrane-3"
    }
  ];
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };

  const customfunction = (event) => {
    setSelectedOperation(event.value); // Update the selected operation state
  };

  const customFuction = (event) => {

    setCurrencySymbol(event.symbol)

  }
  const operationArr = ([
    { value: 'IN', label: "IN" },
    { value: 'OUT', label: "OUT" },
  ]);

  const typeexpenses = ([
    { value: 'Vignette', label: "Vignette" },
    { value: 'Reparation Auto', label: "Reparation Auto" },
    { value: 'Assurance Auto', label: "Assurance Auto" },
    { value: 'Gasoil', label: "Gasoil" },
    { value: 'Frais de deplacement - Reunion', label: "Frais de deplacement - Reunion" },
    { value: 'Transport MP', label: "Transport MP" },
    { value: 'Transport matiere divers', label: "Transport matiere divers" },
    { value: 'Salaire(s) Espece', label: "Salaire(s) Espece" },
    { value: 'Frais Telephone  et Internet', label: "Frais Telephone  et Internet" },
    { value: 'Primes de fin de saison', label: "Primes de fin de saison" },
    { value: 'Reparation PC et accessoires', label: "Reparation PC et accessoires" },
    { value: 'Frais divers', label: "Frais divers" },
    { value: 'Don', label: "Don" },
    { value: 'Achat Matiere premiere', label: "Achat Matiere premiere" },
    { value: 'Autre', label: "Autre" },

  ]);

  const changeExpenseType = (event) => {
    console.log("event");
    console.log(event);
    $("#expense_type_other-block").hide();
    if (event == 'Autre') {
      $("#expense_type_other-block").show();

    }
  }
  const changeOperationType = (event) => {
    console.log("event");
    console.log(event);
    $("#operation_type_other-block").hide();
    if (event == 'Autre') {
      $("#operation_type_other-block").show();
    }
  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Caisse Espece</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/caisse-espece">Caisse Espece</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Caisse Espece</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Caisse Espece Information</h4>
                    {permission && permission.add == 1 && (
                      <FormikProvider value={formik}>
                        <form onSubmit={(e) => {
                          e.preventDefault();
                          if (!isSubmitting) {
                            formik.handleSubmit(e);
                          }
                        }}>

                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Select Operation</label>
                                <Select
                                  className="w-100"
                                  value={operationArr.find(option => option.value == formik.values.operation) || null} // Ensure correct format
                                  name="operation"
                                  //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                  onChange={(selectedOption) => {
                                    handleSelectChange("operation", selectedOption);
                                    customfunction(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={operationArr}
                                  placeholder="Select"


                                />
                                <small>
                                  {backendErrors.operation && (
                                    <span className="form-error mt-1">
                                      {backendErrors.operation}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            {selectedOperation === 'OUT' && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Payed To</label>

                                  <div className="input-group">
                                    <input type="text"
                                      name="payed_to"
                                      value={formik.values.payed_to}
                                      onChange={(e) => {
                                        formik.handleChange(e);
                                        customHandleInput(e);
                                      }}
                                      onBlur={formik.handleBlur}
                                      className="form-control" placeholder="Payed To" />

                                  </div>
                                  <small>
                                    {backendErrors.payed_to && (
                                      <span className="form-error mt-1">
                                        {backendErrors.payed_to}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>

                            )}
                            {selectedOperation === 'OUT' && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Type of Expense</label>
                                  <Select
                                    className="w-100"
                                    value={typeexpenses.find(option => option.value == formik.values.expense_type) || null} // Ensure correct format
                                    name="expense_type"
                                    //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                    onChange={(selectedOption) => {
                                      handleSelectChange("expense_type", selectedOption);
                                      changeExpenseType(selectedOption.value);
                                      // customfunction(selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={typeexpenses}
                                    placeholder="Select"

                                  />
                                  <small>
                                    {backendErrors.expense_type && (
                                      <span className="form-error mt-1">
                                        {backendErrors.expense_type}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                            )}
                            <div className="col-md-6 " id="expense_type_other-block" style={{ display: 'none' }}>
                              <div className="form-group">
                                <label>Expense Type</label>

                                <input
                                  type="text"
                                  name="expense_type_other"
                                  value={formik.values.expense_type_other}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.expense_type_other && (
                                    <span className="form-error mt-1">
                                      {backendErrors.expense_type_other}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            {selectedOperation === 'IN' && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Paid By</label>

                                  <div className="input-group">
                                    <input type="text"
                                      name="paid_by"
                                      value={formik.values.paid_by}
                                      onChange={(e) => {
                                        formik.handleChange(e);
                                        // customHandleInput(e);
                                      }}
                                      onBlur={formik.handleBlur}
                                      className="form-control" placeholder="Paid By" />

                                  </div>
                                  <small>
                                    {backendErrors.paid_by && (
                                      <span className="form-error mt-1">
                                        {backendErrors.paid_by}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>

                            )}

                            {selectedOperation === 'IN' && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Operation Type</label>

                                  <div className="input-group">
                                    <Select
                                      className="w-100"
                                      value={operationtypes.find(option => option.value == formik.values.operation_type) || null} // Ensure correct format
                                      name="operation_type"
                                      //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                      onChange={(selectedOption) => {
                                        handleSelectChange("operation_type", selectedOption);
                                        changeOperationType(selectedOption.value);
                                      }}
                                      onBlur={formik.handleBlur}
                                      options={operationtypes}
                                      placeholder="Select"

                                    />

                                  </div>
                                  <small>
                                    {backendErrors.operation_type && (
                                      <span className="form-error mt-1">
                                        {backendErrors.operation_type}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                            )}
                            {selectedOperation === 'IN' && (
                              <div className="col-md-6 " id="operation_type_other-block" style={{ display: 'none' }}>
                                <div className="form-group">
                                  <label>Operation Type</label>

                                  <input
                                    type="text"
                                    name="operation_type_other"
                                    value={formik.values.operation_type_other}
                                    className="form-input form-control"
                                    placeholder="Enter Autre Operation Type"
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.operation_type_other && (
                                      <span className="form-error mt-1">
                                        {backendErrors.operation_type_other}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                            )}



                            {selectedOperation === 'IN' && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Select Payment Type</label>
                                  <Select
                                    className="w-100"
                                    value={paymenttypes.find(option => option.value == formik.values.payment_type) || null} // Ensure correct format
                                    name="payment_type"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("payment_type", selectedOption);
                                      selectPaymentType(paymenttypes);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={paymenttypes}
                                    placeholder="Select"


                                  />
                                  <small>
                                    {backendErrors.payment_type && (
                                      <span className="form-error mt-1">
                                        {backendErrors.payment_type}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                            )}


                            {checklistshow === 'Cheque' && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Select Cheque Status</label>
                                  <Select
                                    className="w-100"
                                    value={chequelist.find(option => option.value == formik.values.cheque) || null} // Ensure correct format
                                    name="cheque"
                                    //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                    onChange={(selectedOption) => {
                                      handleSelectChange("cheque", selectedOption);
                                      customfunction(selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={chequelist}
                                    placeholder="Select"

                                  />
                                  <small>
                                    {backendErrors.cheque && (
                                      <span className="form-error mt-1">
                                        {backendErrors.cheque}
                                      </span>
                                    )}
                                  </small>
                                </div>
                              </div>
                            )}

                            <div className="col-md-6">
                              <div className="form-group status2">
                                <label>Select Currency</label>

                                <Select
                                  className="w-100"
                                  value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                  name="currency"
                                  //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                  onChange={(selectedOption) => {
                                    handleSelectChange("currency", selectedOption);
                                    customFuction(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={primaryCurrency}
                                  placeholder="Select"
                                />
                                <small>
                                  {backendErrors.currency && (
                                    <span className="form-error mt-1">
                                      {backendErrors.currency}
                                    </span>
                                  )}
                                </small>
                              </div>

                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Amount</label>

                                <div className="input-group">
                                  <input
                                    type="text"
                                    onKeyPress={(event) => {
                                      // Allow only numbers (0-9)
                                      if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                        event.preventDefault();
                                      }
                                    }}
                                    name="amount"
                                    value={formik.values.amount}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Amount" aria-label="Amount" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                    <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                  </div>
                                </div>
                                <small>
                                  {backendErrors.amount && (
                                    <span className="form-error mt-1">
                                      {backendErrors.amount}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Date</label>
                                <input
                                  type="date"
                                  name="date"
                                  value={formik.values.date}
                                  className={
                                    backendErrors.date
                                      ? "form-input form-control input-error datetimepicker"
                                      : "form-input form-control datetimepicker"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>



                            <div className="col-md-12">
                              <label>Note</label>
                              <textarea
                                name="note"
                                value={formik.values.note}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                                className="form-control" placeholder="Note" >
                              </textarea>
                              <small>
                                {backendErrors.note && (
                                  <span className="form-error mt-1">
                                    {backendErrors.note}
                                  </span>
                                )}
                              </small>
                            </div>



                          </div>


                          <div className="text-end mt-4">
                            <button className="btn btn-primary" type="submit" id="form-submit" disabled={isSubmitting || formik.isSubmitting}>
                              {isSubmitting ? "Processing..." : "Add Caisse Espece"}
                            </button>
                          </div>
                        </form>
                      </FormikProvider>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CaisseEspaceAdd;
